export default __webpack_public_path__ + "static/software.stack.performance.02-c99557c915f780e1db75da4a50d37b03.jpg";